import { getUserOSName } from "../utils/BrowserUtils"

export function getDownloadLink() {
  const osName = getUserOSName()
  if (["mac", "win"].indexOf(osName) > -1)
    return "https://api.premagic.com/download/latest/" + osName + "/"

  return null
}
